import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const StarOutlineIcon = ({
  title = 'Outline Star',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 64 61" {...props}>
    {/* prettier-ignore */}
    <path fillRule="evenodd" clipRule="evenodd" d="M21.56 18.632l-19.33 2.81-.151.027c-1.529.336-2.108 2.263-.958 3.384L15.11 38.487l-3.302 19.254-.02.148c-.156 1.56 1.5 2.709 2.922 1.96L32 50.76l17.29 9.09.135.065c1.435.631 3.04-.588 2.768-2.173L48.89 38.487 62.88 24.853l.106-.111c1.039-1.17.375-3.07-1.215-3.3l-19.33-2.81-8.646-17.517c-.734-1.487-2.854-1.487-3.587 0L21.56 18.632zM32 6.519l7.317 14.826.079.144a2 2 0 001.427.95l16.361 2.377-11.839 11.542-.112.119a2 2 0 00-.463 1.65l2.795 16.296-14.634-7.693-.162-.076a2 2 0 00-1.7.076l-14.635 7.693 2.796-16.295.021-.163a2 2 0 00-.596-1.607L6.815 24.816l16.362-2.377a2 2 0 001.506-1.094L32 6.52z" />
  </CreateIconComponent>
);

export default StarOutlineIcon;
